<template>
  <vx-card title="Grafik Izin Terbit" subtitle="Data disajikan berdasarkan periode tahun" class="mb-6">
    <vs-select
      v-model="filterYear"
      class="vx-col w-full md:w-1/4 mb-base"
      @change="fetchData()"
    >
      <vs-select-item
        v-for="(item, index) in yearData"
        :key="index"
        :value="item"
        :text="'Tahun '+item"
        class="w-full"
      />
    </vs-select>
    <global-wrapper
      :loading="loading"
      :loadingType="'avatar-two-line'"
      :loadingList="4"
      :scrollable="true"
      height="500px"
    >
      <Bar
        v-if="showChart"
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chartId="'terbit-chart'"
        :width="width"
        :height="height"
      />
    </global-wrapper>
  </vx-card>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'

export default {
  components: { Bar },
  props: {
    yearData: {
      type: Array,
      required: true,
      default(){
        return [new Date().getFullYear()-1]
      }
    }
  },
  data(){
    return {
      loading: false,
      showChart: false,
      chartOptions: {
        responsive: true,
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
      },
      width: 400,
      height: 130,
      chartData: {
        datasets: [{
          label: `Jumlah Izin Terbit`,
          data: [],
          backgroundColor: ['#40c26b','#40c26b','#40c26b','#40c26b','#40c26b','#40c26b','#40c26b','#40c26b','#40c26b','#40c26b','#40c26b','#40c26b'],
          borderWidth: 1,
          barThickness: 35
        }],
        labels: []
      },
      filterYear: new Date().getFullYear()-1
    }
  },
  mounted(){
    this.fetchData();
  },
  methods: {
    async fetchData(){
      this.loading = true;
      const res = await this.$http.get('/dashboard/izin-terbit-graph-data',{params : {year: this.filterYear}});
      this.chartData.datasets[0].data = res.data.data.graph.datasets;
      this.chartData.labels = res.data.data.graph.labels;
      this.loading = false;
      this.showChart = true;
    }
  }
}
</script>